import React from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "../contexts/AuthContext";

export default function PrivateRoute({ children, allowedRoles = [] }) {
	const { isAuthenticated, hasAnyRole } = useAuth();

	if (!isAuthenticated) {
		return <Navigate to="/login" replace />;
	}

	if (allowedRoles.length > 0 && !hasAnyRole(allowedRoles)) {
		return <Navigate to="/" replace />;
	}

	return children;
}
